import { Injectable } from "@angular/core";
import { ApiService, UtilService, VariablesService } from "../shared/services";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})

export class PremiumServiceService {
  constructor(
    private api: ApiService,
    private variablesService: VariablesService,
    private router: Router,
    private util: UtilService
  ) {}

  isCampaignLoading = false;

  activatePlan(campaignId, plan) {
    const url = environment.APP.API_URLS.ACTIVATE_KETTO_PREMIUM_PLAN(campaignId);
    return this.api.post(url, {plan});
  }

  getCampaign(id, resolve?): void {
    const url = environment.APP.API_URLS.GET_CAMPAIGN(id);
    const qparams = `?with=gallery;medicalbill;guardiankyc;beneficiaryrelation;beneficiaryage;leaderboard;campaigner.avtar;`
    .concat(`beneficiaryname;basicinfo;owner;cause;disease;hospital;manager.entity.avtar;patientNumber;raised;showCampaignerTip;parentCause.campaignerTipSlabs;plan;goalAmountRequest;endDateRequest;multiCampaigns`);
    this.api.get(url + qparams).subscribe({
      next: (res) => {
        this.variablesService.campaign = res.data;
        this.setPremiumServiceList(res.data);
        this.isCampaignLoading = false;
        if (resolve) {
          resolve(true);
        }
      },
      error: (err) => {
        // this.vars.campaignObs.next(null);
        this.router.navigate(['/manage/list'], {
          queryParamsHandling: 'merge'
        });
      }
    });
  }

  setPremiumServiceList(data) {
    if (data.plan) {
      this.variablesService.activeKettoPremiumPlanData = data.plan;
    }
    if (data && data.hasOwnProperty('premium_plans') && data.premium_plans && data.premium_plans.length > 0) {
      const arr = [];
      data.premium_plans.forEach(element => {
        const benefits = element.benefits;
        const eligibleLength = benefits?.eligible?.length || 0;
    
        const includes = [];
        
        benefits?.eligible?.forEach((item, idx) => {
          includes.push({
            id: idx,
            title: item,
            isChecked: true
          });
        });
    
        benefits?.not_eligible?.forEach((item, idx) => {
          includes.push({
            id: eligibleLength + idx,
            title: item,
            isChecked: false
          });
        });
    
        arr.push({
          isCurrentPlan: this.variablesService.activeKettoPremiumPlanData?.info_1 === element?.plan_name ? true : element?.plan_name === 'bronze',
          planDetails: element.title,
          planBtnLabel: `${this.variablesService.activeKettoPremiumPlanData ? (this.variablesService.activeKettoPremiumPlanData?.info_1 === element?.plan_name ? 'Current Plan': 'Upgrade to ' + this.util.toTitleCase(element?.plan_name)): this.util.toTitleCase(element.plan_name) === 'bronze'? 'Current Plan' : 'Upgrade to ' + this.util.toTitleCase(element?.plan_name)}`,
          planName: element.plan_name,
          selected: !!element.selected,
          planPrice: this.getPlanPrice(element),
          includes,
          isRecommended: element?.recommend
        });
      });
      this.variablesService.kettoPremiumPlansList = [...arr];
    }
  }

  getPlanPrice(element) {
    const choice = {
      0: 'Free',
      5: '5% <span>Platform Fee*</span>',
      7: '7% <span>Platform Fee*</span>'
    }
    return choice[element.platform_fee];
  }
}